var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-col',{staticClass:"zone-main-title"},[_c('h1',{staticClass:"main-title"},[_vm._v("\n      Libraires\n      "),_c('span',{staticClass:"separator"})])]),_c('ListeStatsLibraires')],1)}
var staticRenderFns = []

export { render, staticRenderFns }